import { Dropdown } from "react-bootstrap";

interface Props {
  selectedGender?: string;
  onGenderSelect: (gender: string) => void;
  toggleStyles?: React.CSSProperties;
}

const GenderDropdown = ({
  selectedGender,
  onGenderSelect,
  toggleStyles,
}: Props) => (
  <Dropdown
    onSelect={(e) => {
      onGenderSelect(e ?? "");
    }}
  >
    <Dropdown.Toggle
      variant="light"
      className="dropdown-menu-240px"
      style={toggleStyles}
    >
      <p className={selectedGender ? "" : "grey-text"}>
        {selectedGender || "Select a gender"}
      </p>
    </Dropdown.Toggle>

    <Dropdown.Menu className="w-100">
      <Dropdown.Item eventKey="Male">Male</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item eventKey="Female">Female</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item eventKey="Non-binary">Non-binary</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item eventKey="Not disclosed">Not disclosed</Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);

export default GenderDropdown;
